import { Box, Button, Modal } from '@mui/material'
import React, { useState } from 'react'
import ModalCredits from './ModalCredits';

const ButtonBuyCredits = (props) => {
  const [ isModalCreditsVisible, setIsModalCreditsVisible ] = useState(false);

  const handleModalCreditsOpen = () => setIsModalCreditsVisible(true);
  const handleModalCreditsClose = () => setIsModalCreditsVisible(false);

  return (
    <Box>
      <Button onClick={() => { handleModalCreditsOpen() }}>Buy Credits</Button>
      <Modal
        open={isModalCreditsVisible}
        onClose={handleModalCreditsClose}
        aria-labelledby="modal-modal-credits"
        aria-describedby="modal-modal-buy-credits"
      >
        <ModalCredits handleModalCreditsClose={handleModalCreditsClose} />
      </Modal>
    </Box>
  )
}

export default ButtonBuyCredits